import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var activeLoginsRes;
export const activeLoginsTodo = createAsyncThunk('activeLogins', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'active_login_graph',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "sel_year": parseInt(val),
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return activeLoginsRes = res.data
    } catch (error) {
        return activeLoginsRes = error.response.data
    }
})


const activeLoginsSlice = createSlice({
    name: 'activeLogins',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(activeLoginsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('activeLogins', state.data)
            }
        });
        builder.addCase(activeLoginsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default activeLoginsSlice.reducer; 